export default {
  "Shaking": "_Shaking_1nwf9_1",
  "shake": "_shake_1nwf9_1"
};import "ni:sha-256;jqgkIw3zSAc6M2w0trFzE5B9hi1ckz6QRHk-5D5KFR8";